import React from "react";
import { Sparkles, TrendingUp, BarChart3, Users } from "lucide-react";

/**
 * MoreFeatures - Placeholder component for upcoming analytics features
 * Following SOLID principles with clear structure for future expansion
 */
export const MoreFeatures: React.FC = () => {
  const upcomingFeatures = [
    {
      icon: <TrendingUp size={24} />,
      title: "Style Trends",
      description: "Analyze trending styles and popularity metrics",
      status: "Coming Soon",
    },
    {
      icon: <BarChart3 size={24} />,
      title: "Engagement Analytics",
      description: "Track user engagement and interaction patterns",
      status: "In Development",
    },
    {
      icon: <Users size={24} />,
      title: "User Behavior",
      description: "Comprehensive user behavior analysis and insights",
      status: "Planned",
    },
  ];

  return (
    <div className="more-features">
      <div className="features-header">
        <div className="header-icon">
          <Sparkles size={32} />
        </div>
        <h2>More Analytics Features</h2>
        <p>
          Advanced analytics and insights are coming soon to help you understand
          your users better.
        </p>
      </div>

      <div className="features-grid">
        {upcomingFeatures.map((feature, index) => (
          <div key={index} className="feature-card">
            <div className="feature-icon">{feature.icon}</div>
            <div className="feature-content">
              <h3>{feature.title}</h3>
              <p>{feature.description}</p>
              <span
                className={`feature-status ${feature.status
                  .toLowerCase()
                  .replace(" ", "-")}`}
              >
                {feature.status}
              </span>
            </div>
          </div>
        ))}
      </div>

      <div className="features-footer">
        <div className="feedback-section">
          <h4>Have Feature Requests?</h4>
          <p>
            We're always looking to improve. Let us know what analytics features
            would be most valuable for your business.
          </p>
          <button className="feedback-button" disabled>
            Submit Feedback
          </button>
        </div>
      </div>
    </div>
  );
};
